<template>
    <app-modal-view @close="$emit('close')">
        <template #header>
            <div class="level is-mobile">
                <p class="modal-card-title">
                    {{ $t('Community.activity.creation') }}
                </p>
                <div class="buttons">
                    <button
                        v-t="'creation.save'"
                        class="button is-link"
                        @click.prevent.stop="$emit('input')"
                    />
                    <button
                        v-t="'creation.cancel'"
                        class="button is-outlined is-danger"
                        @click.prevent.stop="$emit('close')"
                    />
                </div>
            </div>
        </template>
        <template #body>
            <project-configuration-image
                :image.sync="content.image"
                :can-edit="true"
                class="mb-2"
            />

            <textarea
                v-model="content.area"
                :placeholder="$t('Community.activity.area_placeholder')"
                class="input is-size-5 mb-2"
                type="text"
            />

            <textarea
                v-model="content.title"
                :placeholder="$t('Community.activity.title_placeholder')"
                class="input is-size-5 mb-2"
                type="text"
            />

            <input-rich-text
                v-model="content.shortDescription"
                :placeholder="
                    $t('Community.activity.shortDescription_placeholder')
                "
                class="mb-2"
            />
            <div class="tags">
                <a
                    v-for="tag in tags"
                    :key="tag.value"
                    :class="{
                        [`lb-bain-tag-${tag.category}`]: true,
                        'is-selected': tagIsSelected(tag.value),
                    }"
                    @click="toggleTag(tag.value)"
                >
                    {{ $t(`Constants.BAIN_TAG_${tag.value.toUpperCase()}`) }}
                </a>
            </div>
        </template>
    </app-modal-view>
</template>

<script>
import InputURL from '@/components/InputURL';
import InputRichText from '@/components/InputRichText';
import ProjectConfigurationImage from '@/components/ProjectConfigurationImage';
import AppModalView from '@/components/AppModalView';
import _ from 'underscore';
import {
    ACTIVITY_TYPE_BOOK_EXTENSION,
    ACTIVITY_TYPE_GLOBAL_PROJECT,
} from '@/lib/constants';
export default {
    components: {
        InputURL,
        InputRichText,
        ProjectConfigurationImage,
        AppModalView,
    },
    props: {
        fromClipboard: { type: Boolean, default: false },
        content: {
            type: Object,
            default() {
                return {};
            },
        },

        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            contentBackup: JSON.parse(JSON.stringify(this.content)),
            localBackgroundImage: _.clone(this.backgroundImage),
            backgroundImage: {
                type: Object,
                default: () => {
                    return { value: {} };
                },
            },
        };
    },
    computed: {
        tags() {
            return this.$store.getters.communityActivityTags;
        },
    },
    watch: {
        localBackgroundImage() {
            this.$emit('update:backgroundImage', this.localBackgroundImage);
        },
    },
    methods: {
        tagIsSelected(tag) {
            return _.contains(this.content.tags, tag);
        },
        toggleTag(tag) {
            if (this.tagIsSelected(tag)) {
                this.content.tags = _.without(this.content.tags, tag);
            } else {
                if (!this.content.tags) {
                    this.$set(this.content, 'tags', []);
                }
                this.content.tags.push(tag);
            }
        },
    },
};
</script>

<style scoped>
textarea.input::placeholder,
.url-input input::placeholder {
    color: #aaa;
    font-weight: normal;
    font-style: italic;
    font-size: 1rem;
}
</style>
